export default __webpack_public_path__ + "static/media/Japanese.a9d0a17c.png";